let BlankPage = () => {
    return;
};

export default BlankPage;